export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9928.22d3f3b5.jpg";